
import { Component, Vue, Prop } from "vue-property-decorator";
import { clearFilter } from "@/utils/base";
import { LoginOut } from "@/request/common";
import { GetVersionList } from "@/request/version";
import { mixins } from "vue-class-component";
import { languageMixin } from "@/mixins/languageMixin";
@Component({})
export default class Name extends mixins(languageMixin) {
  private pageW: number = 0;
  private get user() {
    return this.$store.state.user;
  }
  private get href() {
    return window.location.href;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }

  private updatePageWidth() {
    this.pageW = window.innerWidth;
  }

  private mounted() {
    this.updatePageWidth();
    window.addEventListener("resize", this.updatePageWidth);
  }

  private beforeDestroy() {
    window.removeEventListener("resize", this.updatePageWidth);
  }

  private changeLanguage() {
    if (this.language == "English") {
      this.$store.commit("updateLanguage", "Chinese");
    } else {
      this.$store.commit("updateLanguage", "English");
    }
  }
  private goRouter(item: any) {
    if (!item.path) {
      return;
    }
    this.$store.commit("updatePatient", null);
    clearFilter();
    this.$router.push(item.path);
  }
  private handleSystem(command: any) { }
  /**
   * @description 点击切换账号
   */
  private handleCommand(command: any) {
    if (command === "个人信息") {
      this.$router.push("/main/setting/account");
    } else if (command === "退出登录") {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      LoginOut(this, loading)
        .then(() => {
          loading.close();
          this.$message.success("退出成功");
          this.$store.commit("updateToken", "");
          this.$router.push("/access/login");
        })
        .catch(() => {
          loading.close();
        });
    } else if (command === "检测升级") {
      const loading = this.$loading({
        lock: true,
        text: "检测中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      let params: any = {
        params: {
          name: "测评系统",
        },
      };
      GetVersionList(this, params, loading).then((res: any) => {
        console.log(res);
        const version = this.systemInfo.VERSION;
        console.log("当前版本");
        console.log(version);
        if (
          res.items &&
          res.items.length > 0 &&
          res.items[0]["fields"] &&
          res.items[0]["fields"]["软件版本号"] &&
          res.items[0]["fields"]["软件版本号"].length > 0 &&
          res.items[0]["fields"]["软件版本号"][0].text
        ) {
          console.log("最新版本");
          const cVersion = res.items[0]["fields"]["软件版本号"][0].text;
          console.log(cVersion);
          if (cVersion && cVersion != version) {
            this.$confirm("有新版本，是否更新？", "", {
              customClass: "commonConfirm",
              confirmButtonClass: "iconfont icon-anniu4 confirmSure",
              cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
              cancelButtonText: "不更新",
              confirmButtonText: "更新",
              // showCancelButton: false,
              closeOnClickModal: false,
              // closeOnPressEscape: false,
            }).then(() => {
              const url = res.items[0]["fields"]["软件版本URL"].link;
              console.log(url);
              // 使用 Electron 的下载 API
              let downloadLoading = this.$loading({
                lock: true,
                text: "下载中，请稍候...",
                spinner: "el-icon-loading",
                customClass: "loadClass",
                background: "rgba(255, 255, 255, 0.7)",
              });
              window.electronMyAPI
                .downloadFile(url)
                .then((result: any) => {
                  downloadLoading.close();
                  if (result.success) {
                    this.$message.success("下载成功，正在打开...");
                    let openLoading = this.$loading({
                      lock: true,
                      text: "打开中，请稍候...",
                      spinner: "el-icon-loading",
                      customClass: "loadClass",
                      background: "rgba(255, 255, 255, 0.7)",
                    });
                    window.electronMyAPI
                      .openPath(result.path)
                      .then(() => {
                        openLoading.close();
                      })
                      .catch(() => {
                        openLoading.close();
                      });
                  } else {
                    this.$message.error("下载失败：" + result.message);
                  }
                })
                .catch((error: any) => {
                  downloadLoading.close();
                  this.$message.error("下载出错：" + error);
                });
            }).catch(() => {
              // 用户取消更新，不做任何处理
              console.log("用户取消更新");
            });
          } else {
            this.$message.warning("当前已是最新版本");
          }
        }
      });
    }
  }
}
